import React from "react";
import {saveEmployee,getEmployees,deleteEmployee,updateEmployee} from "../../services/employeeService"; // ajuste o caminho
import { useCompany } from "../../contexts/CompanyContext";
import CrudTable from "../../components/Custom/CrudTable";

const EmployeeList = () => {
  const { company } = useCompany();
  
  const columns = [
    { key: "nome", label: "Nome" },
    { key: "horasDia", label: "Horas/Dia" },
    { key: "horasMes", label: "Horas/Mês" },
    { key: "salario", label: "Salário", render: (v) => `R$ ${parseFloat(v).toFixed(2)}` },
    { key: "valorHora", label: "Salário/Hora", render: (_, emp) => `R$ ${(emp.salario / emp.horasMes).toFixed(2)}` },
  ];

  const fields = [
    { name: "nome", label: "Nome" }, 
    { name: "horasDia", label: "Horas/Dia", type: "number" },
    { name: "horasMes", label: "Horas/Mês", type: "number" },
    { name: "salario", label: "Salário", type: "number" },
  ];

  const service = {
    getAll: (companyId) => getEmployees(companyId),
    create: (companyId, data) => saveEmployee(companyId, data),
    update: (companyId, id, data) => updateEmployee(companyId, id, data),
    remove: (companyId, id) => deleteEmployee(companyId, id),
  };

  return (
    <CrudTable
      title="Funcionários"
      columns={columns}
      fields={fields}
      service={service}
      entityName="Funcionário"
      companyId={company.companyId}
    />
  );
};

export default EmployeeList;
